<template>
  <section
    class="content close-date-picker city_collection_reports_pop"
    style="position: relative"
  >
    <div class="box-body">
      <div
        :class="[addButtonClass, { general_reports_btn1: tableCount <= 10 }]"
        class="general_reports_btn"
      >
        <button class="btn gradientbt" @click="refreshReportList">Refresh</button>
        <button class="btn gradientbt ml-5 generate_report" @click="gotoReportGeneration">
          Generate Reports
        </button>
      </div>
      <v-server-table
        ref="dailyCityCollectionReportTable"
        url
        :limit="5"
        :columns="columns"
        :options="options"
        @loaded="onLoaded"
      >
        <template slot="beforeBody">
          <tr v-if="loading" class="VueTables__no-results">
            <td class="text-center" colspan="9">
              <pulse-loader></pulse-loader>
            </td>
          </tr>
        </template>
        <template slot="action" slot-scope="props">
          <div class="c-pointer">
            <a v-if="props.row.fileUrl == ''" disabled
              >Your report is generating. Please wait...</a
            >
            <a
              class="fa fa-download"
              role="button"
              v-if="props.row.fileUrl != ''"
              v-bind:href="props.row.fileUrl"
              target="_blank"
            ></a>
          </div>
        </template>
      </v-server-table>
    </div>

    <div v-if="isGenerateReport" class="">
      <div class="">
        <div class="">
          <div id="details" class="overlay waste_type_pop">
            <div class="overlay_inner">
              <div class="row form-modal">
                <vue-form :state="formstate">
                  <h4 class="text-center">Generate Reports</h4>
                  <div v-if="reportLoading" class="content content-centered">
                    <pulse-loader></pulse-loader>
                    <p>Please wait, report generation is in progress.</p>
                  </div>
                  <div
                    v-if="!reportLoading"
                    class="col-sm-12 scroll_pop"
                    style="padding-top: 15px"
                  >
                    <div v-if="adminCheck == 'superAdmin'" class="col-sm-12">
                      <validate
                        auto-label
                        class="form-group required-field"
                        :class="fieldClassName(formstate.cityId)"
                      >
                        <label>City</label>
                        <select
                          required
                          name="cityId"
                          class="form-control"
                          :disabled="isCityDisable"
                          v-model="dailyCityCollectionReport.cityId"
                          v-on:change="onCheckedCity($event.target.value)"
                        >
                          <option value="" disabled>Select City Name</option>
                          <option v-for="cityId in citys" :value="cityId.id">
                            {{ cityId.name }}
                          </option>
                        </select>
                        <field-messages
                          name="cityId"
                          show="$touched || $submitted"
                          class="form-control-feedback"
                        >
                          <div slot="required">This is a required field</div>
                        </field-messages>
                      </validate>
                    </div>
                    <div class="col-sm-12">
                      <validate
                        auto-label
                        class="form-group required-field"
                        :class="fieldClassName(formstate.startDate)"
                      >
                        <label>Trip Date</label>
                        <date-picker
                          id="startDate"
                          required
                          v-model="dailyCityCollectionReport.startDate"
                          lang="en"
                          name="startDate"
                          input-class="form-control"
                          width="100%"
                          use-utc="true"
                          format="DD-MM-YYYY"
                          @change="datevalidation"
                          :not-after="disabledAfter"
                        ></date-picker>
                        <field-messages
                          name="startDate"
                          show="$touched || $submitted"
                          class="form-control-feedback"
                        >
                          <div slot="required">This is required field</div>
                        </field-messages>
                      </validate>
                    </div>
                  </div>
                </vue-form>
                <div class="form-actions">
                  <button
                    class="mr-5 btn btn-default"
                    type="button"
                    @click="onModalClose"
                  >
                    Cancel
                  </button>
                  <button
                    class="mr-2 btn gradientbt"
                    type="submit"
                    @click="generateReport"
                    :disabled="!(formstate.$dirty && formstate.$valid)"
                  >
                    Generate
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { USER_ROLES } from "../../../config";
import { Event } from "vue-tables-2";
import moment from "moment-timezone";
import { mapState } from "vuex";
import { eventBus, formService, surveysService, reportsService } from "../../../services";
import dateFormatter from "../../utilities/dateFormate";
import { fa } from "faker/lib/locales";
import DatePicker from "vue2-datepicker";
export default {
  name: "dailyCityReports",
  data() {
    return {
      disabledAfter: null,
      show: false,
      showw: false,
      page: null,
      limit: null,
      loading: null,
      dailyCityCollectionReportTable: null,
      parameters: {},
      noResult: true,
      tableCount: "",
      reportLoading: false,
      endLocForDateFilter: "",
      isGenerateReport: false,
      adminCheck: "",
      formstate: {},
      dailyCityCollectionReport: {},
      wardList: [],
      citys: [],
      areas: [],
      isCityDisable: false,
      disabledAfter: new Date(),
      checkedWardValue: null,
      cityList: [],
      vehicleList: [],
      enddateDisabledAfter: null,
      notBeforeEndDate: null,
      endDateFormat: null,
      columns: ["date", "createdAt", "createdBy", "action"],
      options: {
        highlightMatches: true,
        sortable: [],
        headings: {
          cityName: "City",
          date: "Trip Date",
          createdAt: "Generated On",
          createdBy: "Generated By",
          action: "Action",
        },
        templates: {
          scheduleTime(row, query) {
            return dateFormatter(query.scheduleTime);
          },
        },
        perPage: 10,
        sortable: ["cityName", "date", "createdAt", "createdBy"],
        requestFunction: (request) => {
          this.parameters.page = request.page;
          this.parameters.limit = request.limit;
          if (request.orderBy) {
            this.parameters.sortBy = request.orderBy;
          }
          if (request.ascending == 1) {
            this.parameters.sortOrder = "asc";
          } else {
            this.parameters.sortOrder = "dsc";
          }
          if (request.query.status) {
            this.parameters.status = request.query.status;
          }
          if (request.query) {
            this.parameters.searchString = request.query;
          } else {
            this.parameters.searchString = "";
          }
          return reportsService
            .getDailyCityCollectionReportList(this.parameters)
            .catch((error) => {
              console.error("report.requestFunction-error:", error);
              this.$snotify.error("Get List", "Error!");
            });
        },
        responseAdapter: (response) => {
          this.loading = false;
          let dataResp = [];
          response.data.response.forEach((element) => {
            let finalData = element;
            finalData["createdAt"] = element.createdAt
              ? dateFormatter(element.createdAt)
              : "--";
            finalData["date"] = element.startDate
              ? dateFormatter(element.startDate)
              : "--";
            dataResp.push(finalData);
          });
          return {
            data: dataResp,
            count: response.data.totalCount,
          };
        },
        uniqueKey: "_id",
      },
    };
  },
  computed: {
    addButtonClass() {
      if (this.dailyCityCollectionReportTable) {
        this.tableCount = this.dailyCityCollectionReportTable.count;
        return this.dailyCityCollectionReportTable.count >
          this.dailyCityCollectionReportTable.limit ||
          this.dailyCityCollectionReportTable.limit > 10
          ? "shift-add-left"
          : "add-item";
      } else {
        return "add-item";
      }
    },
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    fieldClassName: formService.fieldClassName,

    refreshReportList() {
      this.$refs.dailyCityCollectionReportTable.refresh();
      this.loading = true;
    },
    datevalidation(event) {
      let date = new Date(event);
      let startEpoch = date.getTime();

      if (this.endDateFormat) {
        let endEpoch = new Date(this.endDateFormat).getTime();
        if (startEpoch > endEpoch) {
          this.tripReport.endDate = "";
        }
      }

      this.notBeforeEndDate = new Date(event).toISOString();
      let endDateAfter14Days = new Date(date.setDate(date.getDate() + 14));
      this.enddateDisabledAfter = endDateAfter14Days.toISOString();
      this.isEndDateDisable = false;
    },

    gotoReportGeneration() {
      if (this.adminCheck == "superAdmin") {
        this.areas = [];
      }
      this.dailyCityCollectionReport.cityId = "";
      this.dailyCityCollectionReport.wardId = "";
      this.isGenerateReport = true;
      eventBus.$on("cityIdChanged", this.onChecked);
      if (this.$store.state.auth.cityId.value) {
        this.isCityDisable = true;
        this.dailyCityCollectionReport.cityId = this.$store.state.auth.cityId.value;
      }
    },

    onCheckedCity(id) {
      this.areas = [];
      // this.getWCAList(id);
    },
    onChecked(option) {
      this.dailyCityCollectionReport.cityId = option.value;
    },
    onCheckedWard(value) {
      this.checkedWardValue = true;
    },

    // getWCAList(id) {
    //     let data = [];
    //     return surveysService
    //         .getWasteCollectionAreaList(id)
    //         .then((response) => {
    //             response.data.response.forEach((el) => {
    //                 let val = {};
    //                 val["wardName"] = el.areaName;
    //                 val["wardId"] = el._id;
    //                 data.push(val);
    //             });
    //             this.areas = data.sort((a, b) =>
    //                 a.wardName.localeCompare(b.wardName)
    //             );
    //         })
    //         .catch((error) => {

    //         });
    // },

    generateReport() {
      this.reportLoading = true;
      let reportData = {};
      reportData["type"] = "html";
      reportData["cityId"] = this.dailyCityCollectionReport.cityId;
      reportData["startDate"] = moment(
        String(this.dailyCityCollectionReport.startDate)
      ).format("YYYY-MM-DD");
      // reportData["endDate"] = moment(String(this.dailyCityCollectionReport.endDate)).format(
      //     "YYYY-MM-DD"
      // );

      return reportsService
        .getDailyCityCollectionReport(reportData)
        .then((response) => {
          this.reportLoading = false;
          if (!response.data.error) {
            const renderedHTML = response.data;
            // Open the rendered HTML in a new tab
            const newTab = window.open("", "_blank");
            // newTab.document.open();
            if (newTab) {
              newTab.document.write(renderedHTML);
              newTab.document.close();
            }
            // this.isGenerateReport = false;
            this.$refs.dailyCityCollectionReportTable.refresh();
          } else {
            // this.isGenerateReport = false;
            this.$snotify.error(response.data.error, "Error!");
          }
          this.dailyCityCollectionReport.cityId = "";
          // this.dailyCityCollectionReport.wardId = "";
          this.dailyCityCollectionReport.startDate = "";
          this.dailyCityCollectionReport.endDate = "";
          this.isGenerateReport = false;
        })
        .catch((error) => {
          this.$snotify.error(error.data.message, "Error!");
          this.reportLoading = false;
          this.dailyCityCollectionReport.cityId = "";
          // this.dailyCityCollectionReport.wardId = "";
          this.dailyCityCollectionReport.startDate = "";
          this.dailyCityCollectionReport.endDate = "";
        });
    },
    onModalClose() {
      this.dailyCityCollectionReport.cityId = "";
      this.dailyCityCollectionReport.startDate = "";
      this.dailyCityCollectionReport.endDate = "";
      // this.dailyCityCollectionReport.wardId = "";
      // this.dailyCityCollectionReport.date = "";
      // this.$refs.reports.reset();
      this.isGenerateReport = false;
    },

    action(row) {
      // this.$router.replace({
      //     name: "viewPrimaryTrip",
      //     params: {
      //         _id: row._id,
      //     },
      //     props: row,
      // });
    },
    onLoaded() {
      this.dailyCityCollectionReportTable = this.$refs.dailyCityCollectionReportTable;
    },
    onCheckedCityFilter(option) {
      this.parameters.cityId = option.value;
      this.$refs.dailyCityCollectionReportTable.refresh();
    },
    getCityList() {
      if (this.$store.state.auth.user.role.key === "cityAdmin") {
        const { _id, cityName } = this.$store.state.auth.user.cityId;
        this.citys = [
          {
            id: _id,
            name: cityName,
          },
        ];
        this.isCityDisable = true;
        return;
      }
      // this.loading = true;
      const params = {};
      let cityList = [];
      // params.page = 1;
      // params.limit = 999;
      this.$cityRepository
        .collectionCitysList(params)
        .then((res) => {
          res.data.response.forEach((element) => {
            if (element.status === true) {
              cityList.push({
                name: element.cityName,
                id: element._id,
              });
            }
          });
          cityList.sort((item1, item2) => {
            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
          });
          this.citys = cityList;
        })
        .catch((error) => {
          this.loading = false;
          this.$snotify.error("Get citys list failed", "Error!");
        });
    },
  },
  mounted() {
    eventBus.$on("cityIdChanged", this.onCheckedCityFilter);
    if (this.$store.state.auth.user.role.key === "superAdmin") {
      this.columns.unshift("cityName");
      this.getCityList();
    }
  },
  beforeDestroy() {
    eventBus.$off("cityIdChanged", this.onChecked);
  },
  created() {
    this.adminCheck = this.$store.state.auth.user.role.key;
    let cityIdWCAList =
      this.$store.state.auth.user.cityId && this.$store.state.auth.user.cityId._id
        ? this.$store.state.auth.user.cityId._id
        : "";
    // if (this.adminCheck !== "superAdmin") {
    //     this.getWCAList(cityIdWCAList);
    // }
  },
};
</script>

<style scoped>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 225px;
  margin-left: 250px;
}

.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.inline {
  background-color: rgba(255, 132, 78);
  color: white;
}

.addnew {
  background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
  color: white;
}

.scroll_pop {
  padding-top: 15px;
  height: 327px;
  overflow: auto;
}

.scroll_pop::-webkit-scrollbar {
  width: 5px;
}

.scroll_pop::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.scroll_pop::-webkit-scrollbar-thumb {
  background: #888;
}

.main_select_wrp_relative .modal-dialog {
  width: 50% !important;
}

.main_select_wrp_relative {
  position: absolute;
  right: 30%;
  top: 25px;
}

.filter_wrpp button svg {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.filter_wrpp button {
  display: flex;
  align-items: center;
  margin-right: 5px;
}

.filter_wrpp button:hover {
  background: #0f6940;
  color: #fff;
}

.main_select_wrp_relative + .add-item {
  display: flex;
}

.select_date_wrp .datedrop_boxs {
  position: static;
  width: 100%;
  padding: 0px;
  box-shadow: none;
  border: transparent;
}
.general_reports_btn1 {
  right: 15px !important;
}

.select_date_wrp {
  margin-top: 20px;
}

.select_date_wrp .datedrop_boxs_wrp {
  float: initial;
  background: transparent;
  margin-right: 0;
}

/* .dates_left label {
    color: #000;
} */

.dates_left {
  flex: 0 0 32.5%;
  margin-right: 10px;
}

.clearButton {
  margin-right: 33px;
  opacity: 0.8;
  color: blue;
  text-decoration: underline;
  font-size: large;
}

.filter-wrap .multiselected {
  min-width: 50%;
}

.form-modal-report {
  background: #fff;
}

.report .generate_report_pop .form-modal-report {
  width: 40%;
  padding: 24px 15px;
}

.mx-datepicker-popup {
  top: 37px !important;
}

@media (max-width: 767px) {
  .report .generate_report_pop .form-modal-report {
    width: 90%;
    padding: 15px;
  }
}

.generate_report {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// daily_city_collection_reports.vue?79bf3678